import {
  SET_EMPTY_TABLE,
  SET_LEGENDA_MAPS,
  SW_INIT,
  SW_UPDATE,
  SET_NOTIFICATIONS,
  SET_PROGRESS_UPLOAD,
  SET_TRIGGER_TABLE,
} from "./type";
import LogoDesa from "~/assets/images/logo/desapintar/logo-full.png";
import LogoSidebar from "~/assets/images/logo/desapintar/logo-transparent.png";
import LogoSidebarSM from "~/assets/images/logo/desapintar/logo-ico.png";

let app = {
  maps_legend: null,
  empty_table: false,
  triggerTable: false,
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  serviceWorkerRegistration: null,
  progressUpload: null,
  appConfig: {
    name: "DESPIN",
    version: "1.0",
    description: "Desa Pintar",
    colors: {
      primary: "#F28F46",
    },
    logo: {
      core: LogoDesa,
      largeSidebar: LogoSidebar,
      smallSidebar: LogoSidebarSM,
    },
  },
  notification: [],
};

const appReducers = (state = app, action) => {
  switch (action.type) {
    case SET_EMPTY_TABLE:
      return {
        ...state,
        empty_table: action.payload,
      };
    case SET_LEGENDA_MAPS:
      return { ...state, maps_legend: action.payload };
    case SW_INIT:
      return {
        ...state,
        serviceWorkerInitialized: !state.serviceWorkerInitialized,
      };
    case SW_UPDATE:
      return {
        ...state,
        serviceWorkerUpdated: !state.serviceWorkerUpdated,
        serviceWorkerRegistration: action.payload,
      };
    case SET_NOTIFICATIONS:
      return { ...state, notification: action.payload };
    case SET_PROGRESS_UPLOAD:
      return {
        ...state,
        progressUpload: { ...state.progressUpload, ...action.payload },
      };
    case SET_TRIGGER_TABLE:
      return { ...state, triggerTable: action.payload };
    default:
      return state;
  }
};

export default appReducers;
